/**
 * Утилита для очистки устаревших данных из localStorage
 * согласно новым правилам приватности
 */

const LEGACY_KEYS_TO_REMOVE = [
  'vst_shop_newsletter_subscriber', // старый ключ с email данными
  'vst_shop_newsletter_last_check',
  'vst_shop_newsletter_stats'
];

export const clearLegacyData = (): void => {
  try {
    LEGACY_KEYS_TO_REMOVE.forEach(key => {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
      }
    });
    
    // Очистка localStorage завершена согласно правилам приватности
  } catch (error) {
    console.error('❌ Ошибка при очистке localStorage:', error);
  }
};

export const cleanupOnLoad = (): void => {
  // Выполняем очистку при загрузке приложения
  clearLegacyData();
}; 